// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"089fc8d0","847":"09d95660"}[chunkId] + ".chunk.js";
};